var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedia(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "18px",
    viewBox: "0 0 31 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "10F59273-04DE-4ECF-ADA8-54ED0EC4BE32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Administration",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Live-Tools---Presentation-Mode",
    transform: "translate(-1007.000000, -15.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TopHeader",
    transform: "translate(39.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/",
    transform: "translate(968.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    x: 0.75,
    y: 0.75,
    width: 29.5,
    height: 16.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(8.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,5.5 C15,7.58302939 14.1990075,9.55211804 12.803221,10.999005 L12.294209,10.4711705 C13.5618874,9.15661527 14.2806729,7.39011648 14.2806729,5.49950251 C14.2806729,3.60824663 13.56311,1.84232556 12.294209,0.527834513 L12.803221,0 C14.1990539,1.44744866 15,3.41645707 15,5.49900502 L15,5.5 Z M12.9084559,5.5 C12.9084559,7.00136991 12.3299269,8.42249987 11.3246703,9.46561936 L10.8156583,8.93778485 C11.6934259,8.02755878 12.1891288,6.8088582 12.1891288,5.49998395 C12.1891288,4.20173347 11.7012875,2.97932581 10.8156583,2.06218305 L11.3246703,1.53434854 C12.3305924,2.57746804 12.9084559,3.99851775 12.9084559,5.4999679 L12.9084559,5.5 Z M2.09169869,5.5 C2.09169869,3.99863009 2.67022768,2.57750013 3.67548427,1.53438064 L4.18449631,2.06221515 C3.29886706,2.9805936 2.81102581,4.20237539 2.81102581,5.50001605 C2.81102581,6.80892239 3.30612517,8.02757483 4.18449631,8.93781695 L3.67548427,9.46565146 C2.66956222,8.42253196 2.09169869,7.00148225 2.09169869,5.5000321 L2.09169869,5.5 Z M0,5.5 C0,3.41697061 0.80038881,1.44788196 2.19677885,0.00099497552 L2.70579089,0.528829489 C1.43811244,1.84338473 0.719326968,3.6092416 0.719326968,5.50049749 C0.719326968,7.39111145 1.43688986,9.15767444 2.70579089,10.4721655 L2.19677885,11 C0.800945936,9.55255134 0,7.58354293 0,5.50099498 L0,5.5 Z",
    id: "Fill-1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#EFEFEF",
    cx: 7.5,
    cy: 5.5,
    r: 2
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedia);
export default __webpack_public_path__ + "static/media/Media.2fc2e5994b903565c14e1365103052da.svg";
export { ForwardRef as ReactComponent };